import { TemplateDiffContextState } from './TemplateDiffContext';

export const dispatchState = (
  contentLeft: TemplateDiffContextState['contentLeft'],
  contentRight: TemplateDiffContextState['contentRight'],
  isLoading: TemplateDiffContextState['isLoading'],
  template: TemplateDiffContextState['template'],
) =>
  ({
    type: 'setState',
    payload: { contentLeft, contentRight, isLoading, template },
  }) as const;

export const dispatchCurrentContentIds = (
  currentContentIds: TemplateDiffContextState['currentContentIds'],
) =>
  ({
    type: 'setCurrentContentIds',
    payload: { currentContentIds },
  }) as const;

type ActionTypes = ReturnType<typeof dispatchState | typeof dispatchCurrentContentIds>;

export const templateDiffContextReducer = (
  state: TemplateDiffContextState,
  action: ActionTypes,
) => {
  switch (action.type) {
    case 'setState':
      return {
        ...state,
        isLoading: action.payload.isLoading,
        contentLeft: action.payload.contentLeft,
        contentRight: action.payload.contentRight,
        template: action.payload.template,
      };
    case 'setCurrentContentIds':
      return {
        ...state,
        currentContentIds: action.payload.currentContentIds,
      };
    default:
      return state;
  }
};
